<template>
<Layout heading-text="SysAdmin Manaul View" v-if="type === 'admin'">
  <h1 class="text-center pb-0 text-xl font-bold text-blue-600 sm:text-left md:text-center lg:text-center xl:text-center"></h1>
  <div v-for="hardware1 in hardwares1" :key="hardware1.id"> 
    </div>
  <div id="Admins View"> 

    <div class="grid grid-cols-2" >
      
      <div v-if="!sermonLink && !mobileOpen1 && tab !== 'viewadmins'"><BaseInput class="mt-2 pl-2 px-2" style="color: #C38437" label="Search Sermons" v-model="name" /></div>
      <div class="pt-10">
        <button v-if="currentUserData.mainAdmin === 'yes' && !mobileOpen1 && tab !== 'viewadmins'"
        type="button"
        v-on:click="addIncident();"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-6 w-6" src="../assets/adminplus.png" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Add Sermons</h1>
        </a>
      </button>
        <button v-if="!mobileOpen1 && tab !== 'viewadmins'"
            type="button"
            v-on:click="toggleMobilemenu1(); clear();"
            class="relative inline-flex items-center pl-4 px-5 py-4 pt-3 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/biblecalendar.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Search Dates</h1>
            </a>
       </button>
        <button v-if="!mobileOpen1 && tab !== 'viewadmins'"
            type="button"
            v-on:click=" getSermons(); "
            class="relative inline-flex items-center pl-4 px-5 py-4 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/refresh2.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Refresh</h1>
            </a>
       </button>
       
      <!--<button v-if="!mobileOpen1 && tab !== 'viewadmins'"
        type="button"
        v-on:click="setTab('viewadmins');"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-6 w-6" src="../assets/employeruserprofile.png" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Add Member</h1>
        </a>
      </button>-->
   
    </div>
         
    </div>
     <div v-if="mobileOpen1 && tab !== 'viewadmins'">
        <h1 class="block uppercase tracking-wide text-gray-700 text-lg font-thin mb-2 pt-6">START & END DATE</h1>
        <BaseInput label="" type="date" class=" bg-gray-200 rounded pl-2 px-2" placeholder="..." v-model="searchDate" />
          <BaseInput label="" type="date" style="background-color: #C38437" class=" rounded  pl-2 px-2" placeholder="..." v-model="endDate" />
          <div class="pt-2">
          <button
            type="button"
            v-on:click="getSermonDate(searchDate, endDate); toggleMobilemenu1();"
            class="inline-flex items-center px-2 py-0  hover:bg-yellow-500 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo focus:border-yellow-500 active:bg-yellow-500 transition duration-150 ease-in-out"
              >
              
          <img class="h-12 w-auto" src="../assets/searchBible.png" alt="Workflow" />
        </button>
      </div>
      </div>
    <div v-if="!sermons.length && tab !== 'viewadmins'" class="flex flex-col-2 pl-2">
          <img
            class="rounded-lg h-full"
            src="../assets/nosermons.png"
            alt=""
            />
          
          </div>
     
    <iframe v-if="sermonLink && tab !== 'viewadmins'" class=" block md:hidden h-60 w-full px-2 rounded-lg"  frameborder='0' modestbranding=1  controls=0 rel=0 :src=sermonLink.document></iframe> 
    <div v-if="!sermonLink && tab !== 'viewadmins'" class=" mx-auto p-2 md:max-w-7xl lg:max-w-7xl">
        <div v-for="ser2 in sermons" :key="ser2.id" class="">
    <figure  class="">
      <div class="items-left justify-left pt-1 border-b" >
       
        <div class="font-medium">
          <a class="-mt-2" style="color: #C38437">Listen to Sermon : </a>
               <button 
                    type="button"
                    v-on:click="getCheckDoc(ser2.sermonID); " :id="ser2.sermonID"
                    class=""
                         >
                    <img class="h-8 w-8" src="../assets/audio3.png" alt="Workflow" />
                  </button>
                     <button v-if="currentUserData.mainAdmin === 'yes'" 
                  class="pl-6"
                >
                  <router-link 
                    :to="{ name: 'adminsermonview', params: { id: ser2.id } }"
                    class=""
                    >
                    <img class="h-8 w-8" src="../assets/open1.png" alt="Workflow" /></router-link> 
                </button> 
       
        </div>
        <figcaption class="pl-0 items-left justify-left ">
            <!--<img class="rounded-full w-9 h-9" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/karen-nelson.png" alt="profile picture">-->
            <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Preacher : </a>{{ser2.Pastor}}   </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
              <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Sermon Name :</a> {{ser2.sermonName.slice(0,50)}} </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
               <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Sermon Text :</a> {{ser2.text.slice(0,25)}} </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
               <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Sermon Date :</a> {{new Date(ser2.entryDate).toLocaleDateString()}} {{ser2.entryTime}} </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
      
        </figcaption> </div>
    
    </figure>
    </div>
    </div>
     <iframe v-if="tab !== 'viewadmins'" class="hidden md:block w-full h-60 px-2" frameborder='0' modestbranding=1  controls=0 rel=0 :src=sermonLink.document></iframe>  
   
  
      </div>
  </Layout>
</template>

<script>
//import Layout from './layouts/Main.vue'
import { mapGetters } from "vuex";
import BaseInput from "../components/BaseInput";
//import SearchMembers from "../components/SearchMembers";
//import BaseInput from "../components/BaseInput";
//import CALL from "../data/manuals.json";
//import BaseSelect from "../components/BaseSelect";

export default {
  name: 'SearchIncidents',
  components: { BaseInput},
  
  data() {
    return {
       sermons: [],
        //name : "",
        //mansearch: "",
        //manual : "",
       // baseType: "",
        entryType: "",
        startDate: "",
        endDate: "",
        mobileOpen: false,
        mobileOpen2: false,
        tab: "",
        // mobileOpen : false,
      mobileOpen1 : false,
      searchDate: "",
      sermonLink : "",
      name : "",
      //endDate: "",
      //tab : "",
        tab1: "",
        date : new Date(Date.now()).toLocaleDateString(),
        //CALL,
        
      }
    },
    created(){
      this.type = this.currentUserData.userType;
      //this.email = this.currentUserData.email;
      //this.userStatus = this.currentUserData.status;
      //this.member = this.currentUserData.MainAdmin;
      if (this.type !== "admin") {
        this.$router.push({
        name: "Home",
        });
      }
      this.getSermons();
     // this.getManualNo();
     // this.getReopened();
  
    },
    computed: {
    ...mapGetters(["currentUserData"]),

    },
   watch: {
    name(name) {
      this.getSermonName(name.toLowerCase());
    },
  },
    methods: {
    getSermons() {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("sermons")
        .where("sermonID", ">=", 1)
        .orderBy("sermonID" , "desc")
        .limit(8)
       
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.sermons = users;
      });
      this.sermonLink = ""
      //this.name = ""
    },
    getSermonName(name) {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("sermons")
        .where("search", "array-contains", name)
       
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.sermons = users;
      });
    },
    clear(){
      this.searchDate = "",
      this.endDate = "",
      this.sermonLink = "",
      this.name = ""
    },
          async getCheckDoc(id) {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", id)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
      getSermonDate(searchDate, endDate) {
    const hardwares = [];
    this.$db
      .collection("sermons")
      .where("searchDate", ">=", searchDate)
      .where("searchDate", "<=", endDate)
      .orderBy('searchDate')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.sermons = hardwares;
      this.sermonLink = ""
      //this.sumTravis();
    },  
    getIncidents() {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("entryDate", ">=", "2024-01-01")
      //.where("ticketOwner", "==", 'travis@platinumpos.com')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      });
      this.incidents = hardwares;
    },
    getIncidentsCurrent() {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("date", ">=", this.date)
      //.where("ticketOwner", "==", 'travis@platinumpos.com')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      });
      this.incidents = hardwares;
    },
    getDates(startDate, endDate) {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("entryDate", ">=", startDate)
      .where("entryDate", "<=", endDate)
      .orderBy("entryDate")
      //.where("ticketOwner", "==", 'travis@platinumpos.com')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      });
      this.incidents = hardwares;
    },

    setTab(tab) {
      this.tab = tab;
    },
    setTab1(tab1) {
      this.tab1 = tab1;
    },
       toggleMobilemenu1() {
      this.mobileOpen1 = !this.mobileOpen1;
    },
    getDates2() {
      const userData = this.$db
        .collection("incidents")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("entryDate", ">=", this.startDate)
        .where("entryDate", "<=", this.endDate)
        .orderBy("entryDate")
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.manual = data;
        });
      });
    },
    getManualNo() {
      const userData = this.$db
        .collection("manualID")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("active", "==",'yes')
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.manual = data;
        });
      });
    },
    getClientTypes(calls) {
      return calls.map((call) => {
        return {
          value: `${call.admin}`,
          label: `${call.admin}`,
        };
      });
    },
    getEntryTypes(entryType) {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("entryType", "==", entryType)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.incidents = hardwares;
    },
    getSearch(name) {
    const hardwares = [];
    this.$db
      .collection("manuals")
      .where("search", "array-contains", name)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.hardwares = hardwares;
    },
    getManualSearch(mansearch) {
    const hardwares = [];
    this.$db
      .collection("manuals")
      .where("manualNo", "==", mansearch)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.hardwares = hardwares;
    },
    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
      },
      toggleMobilemenu2() {
      this.mobileOpen2 = !this.mobileOpen2;
      },
    addIncident() {
      this.$router.push({
        name: "addsermon",
      });
    },
     goBack() {
      this.$router.go();
    },
      addMember() {
      this.$router.push({
        name: "adminaddmember",
      });
    },
  
    }
}


</script>